import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Events from "./pages/Events/index";
import Updates from "./pages/Updates/index";
import EventDetail from "./pages/Events/EventDetail";
import UpdateDetail from "./pages/Updates/UpdateDetail";
import Programs from "./pages/Programs/index";
import Contact from "./pages/Contact";
import { ThemeProvider } from "./contexts/ThemeContext";
import ThemeToggle from "./components/ThemeToggle";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import EventsManager from "./pages/Admin/EventsManager";
import EventEditor from "./pages/Admin/EventEditor";
import Login from "./pages/Login";
import DatabaseSeeder from "./pages/Admin/DatabaseSeeder";
import UpdatesManager from "./pages/Admin/UpdatesManager";
import UpdateEditor from "./pages/Admin/UpdateEditor";
import ChatbotController from "./components/ChatbotController";
import ContactManager from "./pages/Admin/ContactManager";
import ChampionshipBidForm from "./pages/ChampionshipBidForm";
import ChampionshipBidManager from "./pages/Admin/ChampionshipBidManager";
import ChampionshipBidVoting from "./pages/Admin/ChampionshipBidVoting";
import ChampionshipBidDetails from "./pages/Admin/ChampionshipBidDetails";
import AdminDashboard from "./pages/Admin/Dashboard";
import UserManager from "./pages/Admin/UserManager";
import AdminSetup from "./pages/Admin/AdminSetup";
import ForgotPassword from "./pages/ForgotPassword";
import Register from "./pages/Register";
import TermsAndConditions from "./pages/Legal/TermsAndConditions";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import Settings from "./pages/Settings";

const libraries = ["places", "marker"];



function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
          libraries={libraries}
        >
          <Router>
            <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
              <Navigation />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/events/:id" element={<EventDetail />} />
                  <Route path="/updates" element={<Updates />} />
                  <Route path="/updates/:id" element={<UpdateDetail />} />
                  <Route path="/programs" element={<Programs />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route
                    path="/admin/events"
                    element={
                      <ProtectedRoute>
                        <EventsManager />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/events/:id"
                    element={
                      <ProtectedRoute>
                        <EventEditor />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/seed"
                    element={
                      <ProtectedRoute>
                        <DatabaseSeeder />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/updates"
                    element={
                      <ProtectedRoute>
                        <UpdatesManager />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/updates/:id"
                    element={
                      <ProtectedRoute>
                        <UpdateEditor />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/contacts"
                    element={
                      <ProtectedRoute>
                        <ContactManager />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/championship-bid" element={<ChampionshipBidForm />} />
                  <Route
                    path="/admin/bids"
                    element={
                      <ProtectedRoute>
                        <ChampionshipBidManager />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/bid-voting"
                    element={
                      <ProtectedRoute>
                        <ChampionshipBidVoting />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/bids/:id"
                    element={
                      <ProtectedRoute>
                        <ChampionshipBidDetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin/users"
                    element={
                      <ProtectedRoute>
                        <UserManager />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/admin/setup" element={<AdminSetup />} />
                  <Route path="/terms" element={<TermsAndConditions />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route 
                    path="/settings" 
                    element={
                      <ProtectedRoute>
                        <Settings />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </main>
              <Footer />
              <ChatbotController />
            </div>
          </Router>
        </LoadScript>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
